<div class="hr-modal-header">
    <div class="hr-close-tooltip">
        <button class="hr-btn-round hr-modal-close" id="hrCloseModal" (click)="closeModal()">
            <svg-icon src="/assets/icons/close.svg"></svg-icon>
        </button>
        <span>Fechar</span>
    </div>
    <h1>Aceitar proposta</h1>
</div>

<div class="hr-modal-body">
    <form class="hr-content-modal hr-content-dados active" [formGroup]="formGroup">
        <span> Para seguir com o processo, marque a opção abaixo e confirme que você aceita digitalmente os termos da
            proposta salarial.</span>

        <div class="modal-checkbox">
            <mat-checkbox  formControlName="proposalAccepted">Li e concordo com os termos da proposta salarial apresentada.
            </mat-checkbox>
        </div>
    </form>
    <button id="save-mfa-btn" class="hr-btn hr-btn-primary" [disabled]="!formGroup.get('proposalAccepted').value" (click)="save()">
        Aceitar proposta salarial
        <ng-template #savingBtn>
            <div class="btn-loader">Loading...</div>
        </ng-template>
    </button>
</div>

<hr-ol-pdf-acceptance #olPdfAcceptance></hr-ol-pdf-acceptance>